import { render, staticRenderFns } from "./IconInShape.vue?vue&type=template&id=f6ef9776&"
import script from "./IconInShape.vue?vue&type=script&lang=ts&"
export * from "./IconInShape.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports